import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	contractDetail: null,
	error: "",
	loading: false,
};

// ADD_contractDetail
export const addContractDetail = createAsyncThunk(
	"contractDetail/addContractDetail",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `contractDetail`,
				data: {
					...values,
				},
			});
			toast.success("Contract Detail added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			// Check if the error response contains the specific message
			if (
				error.response &&
				error.response.data &&
				error.response.data.message
			) {
				toast.error(error.response.data.message); // Display the error message from the server
			} else {
				toast.error("Error in adding Contract Detail. Please try again.");
			}
			console.error(error.message);
			return {
				message: "error",
			};
		}
	}
);


// DELETE_contractDetail
export const deleteContractDetail = createAsyncThunk(
	"contractDetail/deleteContractDetail ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `contractDetail/${id}`,
			});

			toast.success("Contract Detail deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting Contract Detail try again");
			console.log(error.message);
		}
	}
);

// contractDetailS
export const getAllContractDetail = createAsyncThunk(
	"contractDetail/getAllContractDetail",
	async () => {
		try {
			const { data } = await axios.get(`contractDetail/`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateContractDetail = createAsyncThunk(
    "contractDetail/updateContractDetail",
    async ({ id, values }) => {
        console.log("call");
        try {
            const { data } = await axios({
                method: "put",
                url: `contractDetail/${id}`,
                data: {
                    ...values,
                },
            });
            toast.success("Salary Detail updated successfully!");
            return {
                data,
                message: "success",
            };
        } catch (error) {
            // Handle specific error messages from the backend
            if (error.response && error.response.data) {
                const errorMessage = error.response.data.message;
                if (errorMessage) {
                    // Show the specific error message from the backend
                    toast.error(errorMessage);
                } else {
                    // Fallback generic error
                    toast.error("Error in updating Salary Detail");
                }
            } else {
                // Network or other errors
                toast.error("Error in updating Salary Detail. Please try again.");
            }

            console.error("Update error:", error.response?.data || error.message);
            return {
                message: "error",
                error: error.response?.data || error.message
            };
        }
    }
);

const contractDetailSlice = createSlice({
	name: "contractDetail",
	initialState,
	reducers: {
		clearContractDetail: (state) => {
			state.contractDetail = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllContractDetail ======

		builder.addCase(getAllContractDetail.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllContractDetail.fulfilled, (state, action) => {
			state.loading = false;
			state.contractDetail = action.payload;
		});

		builder.addCase(getAllContractDetail.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addContractDetail  ======

		builder.addCase(addContractDetail.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addContractDetail.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addContractDetail.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for updateContractDetail ======

		builder.addCase(updateContractDetail.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateContractDetail.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateContractDetail.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteContractDetail  ======

		builder.addCase(deleteContractDetail.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteContractDetail.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteContractDetail.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default contractDetailSlice.reducer;
export const { clearContractDetail } = contractDetailSlice.actions;
